import { Button } from '@s4l/ds'
import { IconArrowRight } from '@s4l/icons/IconArrowRight'
import { IconInfo } from '@s4l/icons/IconInfo'
import { useS4LContext } from '@s4l/react-context'
import React, { useContext } from 'react'
import { PropertyCardContext } from '../context'

interface IFooterCTAProps {
  onClick?: () => void
}

export const FooterCTA = ({ onClick }: IFooterCTAProps) => {
  const { i18n } = useS4LContext()
  const { isSmallCardVariant, isSoldOut, variant } = useContext(PropertyCardContext)

  if (isSmallCardVariant && isSoldOut) return null

  const shouldShowLeadingIcon = isSoldOut
  const shouldShowTrailingIcon = !isSmallCardVariant && !isSoldOut && variant !== 'lite'

  const handleClick = (e: React.MouseEvent) => {
    if (!onClick) return
    e.preventDefault()
    e.stopPropagation()
    onClick()
  }

  let label: string
  if (isSmallCardVariant || variant === 'lite') {
    label = i18n.formatMessage({ id: 'global.offers' })
  } else if (isSoldOut) {
    label = i18n.formatMessage({ id: 'global.not-available' })
  } else {
    label = i18n.formatMessage({ id: 'global.available' })
  }

  return (
    <Button
      variant="filled-rounded"
      leadingIcon={shouldShowLeadingIcon ? <IconInfo /> : undefined}
      trailingIcon={shouldShowTrailingIcon ? <IconArrowRight /> : undefined}
      size="extraSmall"
      data-testid="cta-button"
      onClick={handleClick}
      onMouseDown={onClick ? (e: React.MouseEvent) => e.stopPropagation() : undefined}
      disabled={isSoldOut}
    >
      {label}
    </Button>
  )
}

FooterCTA.displayName = 'PropertyCard.FooterCTA'
